<template>
  <span>{{animatedValue.toFixed(2)}}{{unit}}</span>
</template>

<script>
import { toFloat } from '../helpers'

export default {
  name: 'animated-number',
  data () {
    return {
      iterator: undefined,
      iterations: 0,
      animatedValue: this.value
    }
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    unit: {
      type: String
    },
    iterationLimit: {
      type: Number,
      default: 1.5
    },
    animationSpeed: {
      type: Number,
      default: 4
    }
  },
  watch: {
    value (newVal, oldVal) {
      const _updateValue = val => toFloat(oldVal >= newVal ? newVal + val : newVal - val)
      const _animateValue = () => {
        this.iterations--
        const incrementBy = this.iterations / 100

        if (this.iterations === 0) clearInterval(this.iterator)
        this.animatedValue = _updateValue(incrementBy)
      }

      // Clear interval if a change occurs mid animation
      if (this.iterator) clearInterval(this.iterator)

      // Converts difference between old and new values to integar steps
      this.iterations = toFloat(Math.abs(newVal - oldVal) * 100)

      const headStart = this.iterations / 100 - this.iterationLimit

      // Pre set the animated value to the excess calculated value
      if (headStart > 0) {
        this.animatedValue = _updateValue(toFloat(headStart))
        this.iterations = toFloat(this.iterationLimit * 100)
      }

      this.iterator = setInterval(_animateValue, this.animationSpeed)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AnimatedNumber.vue